// extracted by mini-css-extract-plugin
export default {"card":"tGiml","wrapper":"yB_gG","logoWrapper":"Lnyem","newLogo":"gkx8o","button":"CiNAB"};